import CryptoJS from 'crypto-js';
import { LocalStorageKeysEnum } from 'constants/common';

export const SENSITIVE_STORAGE_KEYS = [
  LocalStorageKeysEnum.ACCESS_TOKEN,
  LocalStorageKeysEnum.ID_TOKEN,
  LocalStorageKeysEnum.REFRESH_TOKEN
] as const;

export type SensitiveStorageKey = typeof SENSITIVE_STORAGE_KEYS[number];

const ENCRYPTION_PREFIX = 'enc:v1:';

const isSensitiveStorageKey = (key: string): key is SensitiveStorageKey =>
  (SENSITIVE_STORAGE_KEYS as readonly string[]).includes(key);

const getEncryptionSecret = (): string =>
  `scanpay-token-storage-${typeof window !== 'undefined' ? window.location.origin : 'server'}`;

export const encryptStorageValue = (value: string): string => {
  const ciphertext = CryptoJS.AES.encrypt(value, getEncryptionSecret()).toString();
  return `${ENCRYPTION_PREFIX}${ciphertext}`;
};

export const decryptStorageValue = (value: string): string | null => {
  if (!value.startsWith(ENCRYPTION_PREFIX)) {
    return value;
  }

  try {
    const ciphertext = value.slice(ENCRYPTION_PREFIX.length);
    const bytes = CryptoJS.AES.decrypt(ciphertext, getEncryptionSecret());
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);
    return decrypted || null;
  } catch {
    return null;
  }
};

export const isEncryptedStorageValue = (value: string): boolean => value.startsWith(ENCRYPTION_PREFIX);

export { isSensitiveStorageKey };
